import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=db7f6f10&"
import script from "./Classification.vue?vue&type=script&lang=js&"
export * from "./Classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports